import React from 'react';
import { connect } from 'react-redux';
import TapIcon from '../../../services/TapIcon';
import Ax from '../../../components/hoc/Ax';
import HttpAPICall from '../../../services/HttpAPICall';
import { Modal } from 'bootstrap';
import Loader from '../../../components/ui/Loader/Loader';
import TapSelect from '../../../components/ui/TapSelect';
import AppBaseComponent from '../../../components/AppBaseComponent';
import { toast } from 'react-toastify';
import swal from "sweetalert";
import { ISC_SALES_ALLOCATION_URL,ISC_SALES_INVOICE_URL,ISC_SALES_ORDER_URL ,ISC_QUOTATION_URL} from '../../../services/TapApiUrls';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';
import { DisplayListPagination } from '../../../components/TapUi';
import Status from '../../../components/ui/Status';
import DateService from '../../../services/DateService';
import CurrencyFormatter from '../../../services/CurrencyFormatter';
import QuotationDetailModal from '../quotation/QuotationDetailModal';
import TapHelper from '../../../services/TapHelper';
import SalesOrderDetail from '../salesOrder/SalesOrderDetail';
import SalesAllocationDetail from '../salesAllocation/SalesAllocationDetail';
import SalesInvoiceDetail from '../salesInvoice/includes/SalesInvoiceDetail';

class DocumentAndVoucherTabs extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.state                  =   {
            dealData                    :   props.dealData,

            documentTypes               :   [],

            quotation_loading           :   false,
            quotation_listing           :   [],
            quotationlistingMeta        :   null,
            sales_order_listing         :   [],
            soListingMeta               :   null,
            so_loading                  :   false,
            sales_allocation_listing    :   [],     
            saListingMeta               :   null,
            sa_loading                  :   false,     
            sales_invoice_listing       :   [],
            siListingMeta               :   null,
            si_loading                  :   false,
            quotationtotalListingCount  :   0,
            performAction               :   props.performAction && props.performAction == 'N' ? 'N' : 'Y',
            detailType                  :   null,
            detailTransactionId         :   null,

        }

        this.documentsNVoucherBtnRef    =   React.createRef();
        this.salesOrderDetailModalRef   =   React.createRef();
        this.salesAllocationDetailModalRef = React.createRef();
        this.salesInvoiceDetailModalRef = React.createRef();
        this.transactionDetailModalRef = React.createRef();
        
        // this.documentTypeUrl            =   ORG_API_BASE_URL_2  + '/setting/doc_types';
        // this.addDocumentUrl             =   INVENTORY_API_BASE_URL_2 + '/deal/document/add';
        // this.deleteDocumentUrl          =   INVENTORY_API_BASE_URL_2 + '/deal/document/delete';

        this.quotationListUrl           =   ISC_QUOTATION_URL + '/list';
        this.salesOrderListUrl          =   ISC_SALES_ORDER_URL + '/list';
        this.salesAllocationlistingUrl  =   ISC_SALES_ALLOCATION_URL + '/list';
        this.salesInvoiceListUrl        =   ISC_SALES_INVOICE_URL + '/list';
    }

    componentDidMount() {
        this.transactionDetailModal = new Modal(document.getElementById('transactionDetailModal'), { keyboard: false, backdrop: false });
        if((this.props && this.props.dealId) || (this.props && this.props.dealData) ){
            this.initalizeDetailData(this.props)
        }
    
        // this.addDocumentModal           =   new Modal(document.getElementById('addDocumentModal'), {keyboard: false, backdrop :false});         
    }

    initalizeDetailData     =   (pr)    =>  {
        
        let dealData    =  pr.dealData ? pr.dealData : null;
        this.setState({
            dealData : dealData
        },() => {
            // if (this.state.dealData && this.state.dealData.config_data &&  this.state.dealData.config_data.enable_deal_quotation == "Y") {
            //     this.state.dealData.total_quotation && this.state.dealData.total_quotation.voucher_count > 0 && this.getQuotationList(1, dealData.id);
            // } 

            if (this.state.dealData && this.state.dealData.config_data &&  this.state.dealData.config_data.enable_sales_order == "Y") {
                // this.state.dealData.total_sales_order && this.state.dealData.total_sales_order.voucher_count > 0 && 
                this.getSalesOrder(1, dealData.id);
            } 

            if (this.state.dealData && this.state.dealData.config_data &&  this.state.dealData.config_data.enable_sales_allocation == "Y") {
                // this.state.dealData.total_sales_allocation && this.state.dealData.total_sales_allocation.voucher_count > 0 && 
                
                this.getSalesAllocation(1, dealData.id);
            } 

            if (this.state.dealData && this.state.dealData.config_data &&  this.state.dealData.config_data.enable_sales_invoice == "Y") {
                // this.state.dealData.total_sales_invoice && this.state.dealData.total_sales_invoice.voucher_count > 0 &&
                
                this.getSalesInvoice(1, dealData.id);
            } 
        });

    }

   

    // Get Sales Order
    getSalesOrder = (page = 1, search_deal_id = "") => {
        this.setState({ so_loading: true });
        let params = {page: page,search_deal_ids: search_deal_id ? [search_deal_id] : []};
        HttpAPICall.withAthorization('GET', this.salesOrderListUrl, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data || {};
            let listData = respData.list && typeof respData.list === 'object' ? respData.list : respData;
            let warehouses = Array.isArray(respData.warehouses) ? respData.warehouses : [];
            let customers = Array.isArray(respData.customers) ? respData.customers : [];
            let statusList = Array.isArray(respData.status) ? respData.status : [];
            let salesOrderListing = (Array.isArray(listData.data) ? listData.data : []).map((item) => ({
                ...item,
                warehouse: item.warehouse || warehouses.find((warehouse) => String(warehouse.id) === String(item.warehouse_id)) || null,
                customer: item.customer || customers.find((customer) => String(customer.id) === String(item.customer_id)) || null,
                status: item.status && typeof item.status === 'object'
                    ? item.status
                    : (item.status_data || statusList.find((status) => Number(status.id) === Number(item.status_id || item.status)) || null),
            }));
            this.setState({
                sales_order_listing: salesOrderListing,
                soListingMeta: {
                    from: listData.from,
                    to: listData.to,
                    total: listData.total,
                    last_page: listData.last_page,
                    per_page: listData.per_page,
                    current_page: listData.current_page || page
                },
                totalListingCount: listData.total || 0,
            });
        }).then(() => this.setState({ so_loading: false }));
    };

    // Get Sales Allocation
    getSalesAllocation = (page = 1, search_deal_id = "") => {
        this.setState({ sa_loading: true });
        let params = {page: page,search_deal_ids: search_deal_id ? [search_deal_id] : []};
        HttpAPICall.withAthorization('GET', this.salesAllocationlistingUrl, this.props.access_token, params, {}, (resp) => {
            let respData = resp.data || {};
            let listData = respData.list && typeof respData.list === 'object' ? respData.list : respData;
            let warehouses = Array.isArray(respData.warehouses) ? respData.warehouses : [];
            let customers = Array.isArray(respData.customers) ? respData.customers : [];
            let statusList = Array.isArray(respData.status) ? respData.status : (Array.isArray(respData.statuses) ? respData.statuses : []);
            let salesAllocationListing = (Array.isArray(listData.data) ? listData.data : []).map((item) => {
                let warehouse = item.warehouse || item.warehouse_data || warehouses.find((entry) => String(entry.id) === String(item.warehouse_id));
                let customer = item.customer || item.customer_data || customers.find((entry) => String(entry.id) === String(item.customer_id));
                let status = item.status && typeof item.status === 'object'
                    ? item.status
                    : (item.status_data || statusList.find((entry) => Number(entry.id) === Number(item.status_id || item.status)));

                return {
                    ...item,
                    warehouse: warehouse || null,
                    customer: customer || null,
                    status: status || null,
                    total_pending_qty: item.total_pending_qty ?? item.pending_qty ?? item.pending_quantity ?? item.total_pending_quantity ?? item.total_qty_pending ?? 0,
                };
            });
            this.setState({
                sales_allocation_listing: salesAllocationListing,
                saListingMeta: {
                    from: listData.from,
                    to: listData.to,
                    total: listData.total,
                    last_page: listData.last_page,
                    per_page: listData.per_page,
                    current_page: listData.current_page || page
                },
            });
        }).then(() => this.setState({ sa_loading: false }));
    };

    // Get Sales Invoice
    getSalesInvoice = (page = 1, search_deal_id = "") => {
        this.setState({ si_loading: true });
        let params = {page: page,search_deal_ids: search_deal_id ? [search_deal_id] : []};
        HttpAPICall.withAthorization("GET", this.salesInvoiceListUrl, this.props.access_token, params, {}, (resp) => {
            let respData = (resp && resp.data) || {};
            let listData = respData.list && typeof respData.list === 'object' ? respData.list : respData;
            let warehouses = Array.isArray(respData.warehouses) ? respData.warehouses : [];
            let customers = Array.isArray(respData.customers) ? respData.customers : [];
            let statusList = Array.isArray(respData.status) ? respData.status : [];

            let salesInvoiceListing = (Array.isArray(listData.data) ? listData.data : []).map((item) => {
                let warehouse = item.warehouse || item.warehouse_data || warehouses.find((entry) => String(entry.id) === String(item.warehouse_id)) || null;
                let customer = item.customer || item.customer_data || customers.find((entry) => String(entry.id) === String(item.customer_id)) || null;
                let statusData = item.status_data || (item.status && typeof item.status === 'object' ? item.status : statusList.find((entry) => Number(entry.id) === Number(item.status_id || item.status)) || null);

                return {
                    ...item,
                    warehouse,
                    customer,
                    status_data: statusData,
                };
            });

            this.setState({
                sales_invoice_listing: salesInvoiceListing,
                siListingMeta: {
                    from: listData.from || 0,
                    to: listData.to || 0,
                    total: listData.total || 0,
                    last_page: listData.last_page || 1,
                    per_page: listData.per_page || 0,
                    current_page: listData.current_page || page,
                },
                quotationtotalListingCount: listData.total || 0,
            });
        }).then(() => this.setState({ si_loading: false }));
    };

    
    openSalesOrderDetail = (transaction_id) => {
        this.setState({ detailType: 'salesOrder', detailTransactionId: transaction_id }, () => this.transactionDetailModal.show());
    }

    openSalesAllocationDetail = (transaction_id) => {
        this.setState({ detailType: 'salesAllocation', detailTransactionId: transaction_id }, () => this.transactionDetailModal.show());
    }

    openSalesInvoiceDetail = (transaction_id) => {
        this.setState({ detailType: 'salesInvoice', detailTransactionId: transaction_id }, () => this.transactionDetailModal.show());
    }

    transactionDetailsModalJsx = () => {
        return (
            <div className="modal fade" id="transactionDetailModal" tabIndex="-1">
                <div className="modal-dialog modal-xl modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Transaction Id : {this.state.detailTransactionId || '-'}</h5>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                        </div>
                        <div className="modal-body">
                            {this.state.detailType === 'salesOrder' && <SalesOrderDetail salesID={this.state.detailTransactionId} />}
                            {this.state.detailType === 'salesAllocation' && <SalesAllocationDetail allocationId={this.state.detailTransactionId} />}
                            {this.state.detailType === 'salesInvoice' && <SalesInvoiceDetail transaction_id={this.state.detailTransactionId} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    vouchersJsx     =   ()  =>  {
        let dealData = this.state.dealData;
       
        return (
            <>
            {
                dealData 
                ?
                <>
                {dealData.config_data && dealData.config_data.enable_sales_order && dealData.config_data.enable_sales_order === "Y" && (
                    <Ax>
                        <div className="tab_content_wrapper mt-2">
                            <span className="content_heading">Sales Order</span>
                        </div>
                        <table className="table table-hover table-bordered table-sm my-2">
                            <thead className="table-secondary">
                                <tr>
                                    <th colSpan={6}>Total Sales Order Amount</th>
                                    <td className="text-end">
                                     {dealData && dealData.total_sales_order
                                      ? TapHelper.numberFormatter(dealData.total_sales_order.total_amount, 2)
                                       : "-"}</td>

                                </tr>
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>
                                        S.no
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Date
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Transaction ID
                                    </th>
                                    <th scope="col" style={{ width: "25%" }}>
                                        Customer
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Currency
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Amount
                                    </th>
                                    <th scope="col" style={{ width: "16%" }}>
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.so_loading ? (
                                    <tr>
                                        <td className="text-center" colSpan="7">
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : this.state.sales_order_listing &&
                                    this.state.sales_order_listing.length > 0 ? (
                                    <>
                                        {this.state.sales_order_listing.map(
                                            (item, index) => {

                                                return (
                                                    <tr key={index}>
                                                        <td>{this.state.soListingMeta ? this.state.soListingMeta.from + index : index}</td>
                                                        <td>{item.transaction_date ? DateService.dateTimeFormat(item.transaction_date, 'DD-MMM-YYYY') : ""}</td>
                                                        <td>
                                                            <button type="button" className="btn btn-link p-0 link-primary text-center" onClick={() => this.openSalesOrderDetail(item.transaction_id)}>
                                                                {item.transaction_id}
                                                            </button>
                                                        </td>
                                                        <td className='text-capitalize'>{item.customer ? <div>{item.customer.name}</div> : "-"}</td>

                                                        <td className="text-center">{item.currency}</td>
                                                        <td className="text-end">{item.currency ? item.currency : "INR"} <CurrencyFormatter currencyCode={item.currency ? item.currency : "INR"} amount={parseFloat(item.total_amount_vc ? item.total_amount_vc : 0).toFixed(2)} />

                                                        </td>
                                                        <td className='text-center'>{item.status ? item.status.name : '-'}</td>

                                                    </tr>
                                                );
                                            }
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={7}>
                                            No Records
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <DisplayListPagination
                            meta={this.state.soListingMeta}
                            onPageChange={(e) =>
                                this.getSalesOrder(e.selected + 1)
                            }
                        />
                    </Ax>
                )}
                {dealData && dealData.config_data && dealData.config_data.enable_sales_allocation && dealData.config_data.enable_sales_allocation === "Y" && (
                    <Ax>
                        <div className="tab_content_wrapper mt-2">
                            <span className="content_heading">Sales Allocation</span>
                        </div>
                        <table className="table table-hover table-bordered table-sm my-2">
                            <thead className="table-secondary">
                                <tr>
                                    <th colSpan={6}>Total Sales Allocation Amount</th>
                                     <td className="text-end">{dealData && dealData.total_sales_allocation
                                      ? TapHelper.numberFormatter(dealData.total_sales_allocation.total_amount, 2)
                                       : "-"}</td>
                                </tr>
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>
                                        S.no
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Date
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Transaction ID
                                    </th>
                                    <th scope="col" style={{ width: "25%" }}>
                                        Customer
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Total Qty
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Pending Qty
                                    </th>
                                    <th scope="col" style={{ width: "16%" }}>
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.sa_loading ? (
                                    <tr>
                                        <td className="text-center" colSpan="7">
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : this.state.sales_allocation_listing &&
                                    this.state.sales_allocation_listing.length > 0 ? (
                                    <>
                                        {this.state.sales_allocation_listing.map(
                                            (item, index) => {

                                                return (
                                                    <tr key={index}>
                                                        <td>{this.state.saListingMeta ? this.state.saListingMeta.from + index : index}</td>
                                                        <td>{item.transaction_date ? DateService.dateTimeFormat(item.transaction_date, 'DD-MMM-YYYY') : ""}</td>
                                                        <td>
                                                            <button type="button" className="btn btn-link p-0 link-primary text-center" onClick={() => this.openSalesAllocationDetail(item.transaction_id)}>
                                                                {item.transaction_id}
                                                            </button>
                                                        </td>
                                                        <td className='text-capitalize'>{item.customer ? <div>{item.customer.name}</div> : "-"}</td>
                                                        <td>{item.total_qty}</td>
                                                        <td className="text-center">{item.total_pending_qty}</td>
                                                        <td className='text-center'>{item.status ? item.status.name : '-'}</td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={7}>
                                            No Records
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        <DisplayListPagination
                            meta={this.state.saListingMeta}
                            onPageChange={(e) =>
                                this.getSalesAllocation(e.selected + 1)
                            }
                        />
                    </Ax>
                )}
                
                 {
                 dealData && dealData.config_data && dealData.config_data.enable_sales_invoice && dealData.config_data.enable_sales_invoice === "Y" && (
                    <Ax>
                        <div className="tab_content_wrapper mt-2">
                            <span className="content_heading">Sales Invoice</span>
                        </div>
                        <table className="table table-hover table-bordered table-sm my-2">
                            <thead className="table-secondary">
                                <tr>
                                    <th colSpan={7}>Total Sales Invoice Amount</th>
                                    <td className="text-end">
                                        
                                        {dealData && dealData.total_sales_invoice
                                      ? TapHelper.numberFormatter(dealData.total_sales_invoice.total_amount, 2)
                                       : "-"}</td>

                                </tr>
                                <tr>
                                    <th scope="col" style={{ width: "5%" }}>
                                        S.no
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Transaction ID
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Date
                                    </th>
                                    <th scope="col" style={{ width: "15%" }}>
                                        Warehouse
                                    </th>
                                    <th scope="col" style={{ width: "25%" }}>
                                        Customer
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Total Quantity
                                    </th>
                                    <th scope="col" style={{ width: "12%" }}>
                                        Amount
                                    </th>
                                    <th scope="col" style={{ width: "16%" }}>
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.si_loading ? (
                                    <tr>
                                        <td className="text-center" colSpan="8">
                                            <Loader />
                                        </td>
                                    </tr>
                                ) : this.state.sales_invoice_listing &&
                                    this.state.sales_invoice_listing.length > 0 ? (
                                    <>
                                        {this.state.sales_invoice_listing.map(
                                            (item, index) => {

                                                return (
                                                    <tr key={index}>
                                                        <td>{this.state.siListingMeta ? this.state.siListingMeta.from + index : index}</td>
                                                        <td>
                                                            <button type="button" className="btn btn-link p-0 link-primary text-center" onClick={() => this.openSalesInvoiceDetail(item.transaction_id)}>
                                                                {item.transaction_id}
                                                            </button>
                                                        </td>
                                                        <td>{item.transaction_date ? DateService.dateTimeFormat(item.transaction_date, 'DD-MMM-YYYY') : ""}</td>
                                                        <td className="text-start">{item.warehouse?.name || "-"}</td>
                                                        <td className='text-capitalize'>{item.customer ? <div>{item.customer.name}</div> : "-"}</td>

                                                        <td className="text-center">{item.total_qty}</td>
                                                        <td className="text-end">
                                                            {item.total_amount ? <CurrencyFormatter currencyCode={item.currency || 'INR'} amount={parseFloat(item.total_amount).toFixed(2)} /> : 0}
                                                        </td>
                                                        <td className='text-center'>{item.status_data ? item.status_data.name : '-'}</td>
                                                    </tr>
                                                );
                                            }
                                        )}
                                    </>
                                ) : (
                                    <tr>
                                        <td className="text-center" colSpan={8}>
                                            No Records
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        {
                            this.state.siListingMeta &&
                            typeof this.state.siListingMeta === 'object' &&
                            this.state.siListingMeta !== null &&
                            this.state.siListingMeta.total !== undefined && (
                                <DisplayListPagination
                                    meta={this.state.siListingMeta}
                                    onPageChange={(e) =>
                                        this.getSalesInvoice(e.selected + 1)
                                    }
                                />
                            )
                        }

                    </Ax>
                )
                }
                </>
                : null     
            }
            
            </>
        )
    }

    render          = ()  =>  {
        return (<> 
          {this.vouchersJsx()}
                    {this.transactionDetailsModalJsx()}
        </>);
    }
}

const mapStateToProps = state => {
    return {
        access_token            :   state.auth.access_token,
        default_currency        :   state.app && state.app.default_currency ? state.app.default_currency : 'INR',
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(DocumentAndVoucherTabs);